import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { EnvValidator } from '@/components/EnvValidator';
import { AuthProvider } from '@/contexts/AuthContext';
import { router } from '@/router';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <EnvValidator>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </EnvValidator>
  </StrictMode>,
);
